import React from 'react'

import Popup from '@/shared/components/layers/Popup/Popup'
import TableView from '@/shared/components/organism/TableView/TableView'

import css from '../TopUsers/TopUsers.module.css'
import{ ObjectTopItem } from './ObjectTop'
import { Input } from '@/shared/components/common/Input/Input'
import { Select } from '@/shared/components/common/Select/Select'
import { PlanTypeInterface } from '@/entities/Plan/model/plan.types'

type ObjectTopPopupProps = {
  title: string
  open: boolean
  loading: boolean
  onClose: () => void
  planTypes?: PlanTypeInterface[]
  data: ObjectTopItem[]
  isPeriod?: boolean
  setIsPeriod?: (p: boolean) => void
  valueFilter?: string
  setValueFilter?: (p: string) => void
  typeId?: number
  setTypeIdState?: (p: number) => void
}

const ObjectTopPopup: React.FC<ObjectTopPopupProps> = ({
  open,
  onClose,
  loading,
  title,
  data,
  planTypes,

  isPeriod, setIsPeriod,
  valueFilter, setValueFilter,
  typeId, setTypeIdState
}) => {
  return (
    <Popup 
      open={open}
      onClose={onClose} 
      title={title}
      size='xl' 
      fullHeight
    >
      <div className={css.settings}>
          <Input
            type='checkbox'
            checked={isPeriod}
            label='За все время'
            onChange={e => setIsPeriod && setIsPeriod(e.target.checked)}
          />

          {setValueFilter ? (
            <Input
              type='number'
              value={valueFilter}
              label='Минимальное значение'
              onChange={e => setValueFilter && setValueFilter(e.target.value)}
            />
          ) : null}

          {setTypeIdState && planTypes ? (
            <Select
              value={String(typeId)}
              onChange={val => setTypeIdState(Number(val))}
              options={planTypes.filter(pt => pt.code.includes('EMPLOYEE')).map(pt => ({
                value: String(pt.id),
                label: pt.name
              }))}
            />
          ) : null}
      </div>

      <TableView loading={loading} data={data.filter(i => {
        const value = Number(String(i.value).replace(/[\s%₽,]+/g, ''))
        const min = Number(valueFilter)
        let result
        if (valueFilter) {
          result = value > min
        } else {
          result = true
        }
        return result
      }).map(u => ({
        'Место': u.place,
        'Название': u.name,
        'Значение': u.value
      }))}/>
    </Popup>
  )
}

export default ObjectTopPopup